/* eslint-disable no-empty-pattern */
import {call, put, delay} from 'redux-saga/effects'
import {push} from 'connected-react-router'
import PublicationsActions from '../Redux/PublicationsRedux'
import AuthActions from '../Redux/AuthRedux'
import ErrorsActions from '../Redux/ErrorsRedux'

export function* getPublications(api, authApi, {page, page_size, search, filter, sort, nextPage}) {
  try {
    const response = yield call(api.getPublications, page, page_size, search, filter, sort, nextPage)
    if (response && response.ok) {
      yield put(PublicationsActions.publicationsSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationsActions.publicationsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getPublications(api, authApi, {page, page_size, search, filter, sort, nextPage})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationsActions.publicationsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getFollowingPublications(api, authApi, {page, page_size, search, filter, sort, nextPage}) {
  try {
    const response = yield call(api.getFollowingPublications, page, page_size, search, filter, sort, nextPage)
    if (response && response.ok) {
      yield put(PublicationsActions.followingPublicationsSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationsActions.publicationsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getFollowingPublications(api, authApi, {page, page_size, search, filter, sort, nextPage})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationsActions.publicationsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getAdvertiserPublications(api, authApi, {id, page, page_size, search, filter, sort, nextPage}) {
  try {
    const response = yield call(api.getAdvertiserPublications, id, page, page_size, search, filter, sort, nextPage)
    if (response && response.ok) {
      yield put(PublicationsActions.advertiserPublicationsSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationsActions.publicationsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getAdvertiserPublications(api, authApi, {id, page, page_size, search, filter, sort, nextPage})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationsActions.publicationsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getFolderPublications(api, authApi, {id, page, page_size, search, filter, sort, nextPage}) {
  try {
    const response = yield call(api.getFolderPublications, id, page, page_size, search, filter, sort, nextPage)
    if (response && response.ok) {
      yield put(PublicationsActions.folderPublicationsSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationsActions.publicationsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getFolderPublications(api, authApi, {id, page, page_size, search, filter, sort, nextPage})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationsActions.publicationsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getPreparedPublications(api, authApi, {page, page_size, search, filter, sort, nextPage}) {
  try {
    const response = yield call(api.getPreparedPublications, page, page_size, search, filter, sort, nextPage)
    if (response && response.ok) {
      yield put(PublicationsActions.preparedPublicationsSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationsActions.publicationsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getPreparedPublications(api, authApi, {page, page_size, search, filter, sort, nextPage})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationsActions.publicationsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getScheduledPublications(api, authApi, {page, page_size, search, filter, sort, nextPage}) {
  try {
    const response = yield call(api.getScheduledPublications, page, page_size, search, filter, sort, nextPage)
    if (response && response.ok) {
      yield put(PublicationsActions.scheduledPublicationsSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationsActions.publicationsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getScheduledPublications(api, authApi, {page, page_size, search, filter, sort, nextPage})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationsActions.publicationsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getListPublications(api, authApi, {id, page, page_size, search, filter, sort, nextPage}) {
  try {
    const response = yield call(api.getListPublications, id, page, page_size, search, filter, sort, nextPage)
    if (response && response.ok) {
      yield put(PublicationsActions.listPublicationsSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationsActions.publicationsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getListPublications(api, authApi, {id, page, page_size, search, filter, sort, nextPage})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationsActions.publicationsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* deleteListPublications(api, authApi, {id, data}) {
  try {
    const response = yield call(api.deleteListPublications, id, data)
    if (response && response.ok) {
      yield put(PublicationsActions.deleteListPublicationsSuccess(true))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationsActions.publicationsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* deleteListPublications(api, authApi, {id, data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationsActions.publicationsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getPublication(api, authApi, {id}) {
  try {
    const response = yield call(api.getPublication, id)
    if (response && response.ok) {
      yield put(PublicationsActions.publicationSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationsActions.publicationsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getPublication(api, authApi, {id})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationsActions.publicationsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* followAuthor(api, authApi, {authorId}) {
  try {
    const response = yield call(api.followAuthor, authorId)
    if (response && response.ok) {
      yield put(PublicationsActions.followAuthorSuccess(authorId, response.data.followed))
      yield* getFollowingSavedCount(api, authApi, {})
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationsActions.publicationsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* followAuthor(api, authApi, {authorId})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationsActions.publicationsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* savePublication(api, authApi, {publicationId, folderId}) {
  try {
    const response = yield call(api.savePublication, publicationId, folderId)
    if (response && response.ok) {
      yield put(PublicationsActions.savePublicationSuccess(publicationId, response.data.saved))
      yield* getFollowingSavedCount(api, authApi, {})
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationsActions.publicationsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* savePublication(api, authApi, {publicationId, folderId})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationsActions.publicationsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getReportReasons(api, authApi, {}) {
  try {
    const response = yield call(api.getReportReasons)
    if (response && response.ok) {
      yield put(PublicationsActions.reportReasonsSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationsActions.reportFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getReportReasons(api, authApi, {})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationsActions.reportFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* sendReport(api, authApi, {id, data}) {
  try {
    const response = yield call(api.sendReport, id, data)
    if (response && response.ok) {
      yield put(PublicationsActions.sendReportSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationsActions.reportFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* sendReport(api, authApi, {id, data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationsActions.reportFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getFollowingSavedCount(api, authApi, {}) {
  try {
    const response = yield call(api.getFollowingSavedCount)
    if (response && response.ok) {
      yield put(PublicationsActions.followingSavedCountSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(PublicationsActions.followingSavedCountFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getFollowingSavedCount(api, authApi, {})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(PublicationsActions.followingSavedCountFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* deleteRestorePublication(api, authApi, {publicationId, data}) {
  try {
    yield delay(2000)
    yield put(PublicationsActions.deleteRestorePublicationSuccess(true, publicationId))

    // const response = yield call(api.deleteRestorePublication, publicationId, data)
    // if (response && response.ok) {
    //   yield put(PublicationsActions.deleteRestorePublicationSuccess(response.data))
    // } else {
    //   if (response && response.data) {
    //     if (response.status === 401) {
    //       yield put(ErrorsActions.errorSave(null))
    //     } else if (response.status === 500) {
    //       yield put(ErrorsActions.errorSave('Server response error'))
    //     } else {
    //       yield put(ErrorsActions.errorSave(response.data))
    //     }
    //   } else {
    //     yield put(ErrorsActions.errorSave('Server response error'))
    //   }
    //   yield put(PublicationsActions.publicationsFetchingReset())
    // }

    // if (response && response.status === 401) {
    //   const res = yield call(authApi.tokenRefresh)
    //   if (res && res.access) {
    //     yield put(AuthActions.updateTokens(res.access, res.refresh))
    //     yield* deleteRestorePublication(api, authApi, {publicationId, data})
    //   } else {
    //     yield put(AuthActions.logout())
    //     yield put(push('/login'))
    //   }
    // }
  } catch (e) {
    yield put(PublicationsActions.publicationsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}
